
import { Vue, Options } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { IFormDetail } from '@/utils/types'

@Options({
  components: {},
  emits: ['update:modelValue'],
})
export default class ChatPreview extends Vue {
  @Prop({ default: () => [] })
  formFields!: IFormDetail[]

  @Prop({ default: '' })
  formTitle!: string

  @Prop({ default: true })
  showTitle!: boolean

  @Prop({ default: () => ({}) })
  modelValue!: Record<string, any>

  previewMessages: Array<{
    type: string
    text: string
    sent: boolean
    name?: string
  }> = []

  get avatarUrl() {
    return window.location.origin + '/img/default-user-avatar.png'
  }

  get noAvatarUrl() {
    return window.location.origin + '/img/default-user-avatar.png'
  }

  @Watch('formFields', { immediate: true, deep: true })
  onFormFieldsChange() {
    this.generatePreviewMessages()
  }

  generatePreviewMessages() {
    this.previewMessages = []

    if (!this.formFields || this.formFields.length === 0) {
      return
    }

    // Generate preview messages based on form fields
    this.formFields.forEach((field) => {
      if (field.field_name && field.field_name.trim() !== '') {
        this.previewMessages.push({
          type: 'text',
          text: field.field_name,
          sent: false,
          name: 'Bot',
        })

        this.previewMessages.push({
          type: 'text',
          text: field.option_type as string,
          sent: true,
        })
      }
    })
  }
}
